var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", [
        _c("p", { staticClass: "result-panel-text" }, [
          _vm._v(_vm._s(_vm.caption))
        ]),
        _vm._v(" "),
        !_vm.isSearching && _vm.items.length === 0
          ? _c("div", [
              _c("p", { staticClass: "result-panel-text" }, [
                _vm._v(
                  "\n        Please try searching in the Entities tab or update your search and try again\n      "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.isSearching
          ? _c("div", [_c("AxSpinner", { attrs: { show: true } })], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSearching && _vm.items.length !== 0
          ? _c(
              "div",
              _vm._l(_vm.items, function(item, index) {
                return _c(
                  "ul",
                  { key: index, staticClass: "ax-results-panel__group" },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "ax-results-panel__item",
                        class: _vm.itemClassForIndex(index)
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "ax-results-panel__item-link",
                            class: item.additionalClasses,
                            attrs: { href: item.href, target: "_self" },
                            on: {
                              click: function($event) {
                                return _vm.navigateAction($event, item)
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "ax-results-panel__item-label",
                              domProps: {
                                innerHTML: _vm._s(_vm.itemLabelHtml(item))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "ax-results-panel__item-shortcut"
                              },
                              [_vm._v(_vm._s(item.shortcut))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "ax-results-panel__item-target" },
                              [
                                item.target === "_blank"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "ax-results-panel__item-target-link popout",
                                        attrs: {
                                          href: item.href,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "ax-icon--pop-out"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }